// extracted by mini-css-extract-plugin
module.exports = {"masonryGrid":"SrIRX0MX","col":"I1zGkQeT","skeletonItem":"RMG4HGD3","pulse":"susxsPDY","imageplaceholder":"YuHFJDL9","textplaceholder":"izX0spoW","short":"__55Z1hpoe"};